export default __webpack_public_path__ + "static/media/image21.5be77862.png";